import { EApplicationStatus, EApplicationType } from '@/interfaces'
import { FaArchive } from 'react-icons/fa'
import {
  FaHouseCircleCheck,
  FaHouseCircleXmark,
  FaListCheck,
} from 'react-icons/fa6'
import {
  MdContentPasteSearch,
  MdOutlineChangeCircle,
  MdOutlinePublishedWithChanges,
} from 'react-icons/md'

export const APPLICATION_TYPES = [
  {
    value: EApplicationType.IMPROVEMENT,
    label: 'Mejora de Vivienda',
  },
  {
    value: EApplicationType.URBAN_LIVING,
    label: 'Vivienda Urbana',
  },
  {
    value: EApplicationType.RURAL_LIVING,
    label: 'Vivienda Rural',
  },
]

export const APPLICATION_STATUS = [
  {
    icon: null,
    value: EApplicationStatus.WITHOUT_START,
    label: 'Sin iniciar',
    nextStatusAuto: true,
    nextStatus: [EApplicationStatus.IN_PROCESS],
  },
  {
    icon: null,
    value: EApplicationStatus.IN_PROCESS,
    label: 'En proceso',
    nextStatusAuto: true,
    nextStatus: [EApplicationStatus.COMPLETED],
  },
  {
    icon: null,
    value: EApplicationStatus.COMPLETED,
    label: 'Completado',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.IN_REVIEW],
  },
  {
    className: 'in-review',
    icon: <MdContentPasteSearch />,
    value: EApplicationStatus.IN_REVIEW,
    label: 'Iniciar revisión',
    nextStatusAuto: false,
    nextStatus: [
      EApplicationStatus.CORRECTLY_FILLED,
      EApplicationStatus.CHANGES_REQUIRED,
    ],
  },
  {
    className: 'changes-required',
    icon: <MdOutlineChangeCircle />,
    value: EApplicationStatus.CHANGES_REQUIRED,
    label: 'Requiere corrección',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.CHANGES_APPLIED],
  },

  {
    className: 'changes-applied',
    icon: <MdOutlinePublishedWithChanges />,
    value: EApplicationStatus.CHANGES_APPLIED,
    label: 'Corregido',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.IN_REVIEW],
  },
  {
    className: 'correctly-filled',
    icon: <FaListCheck />,
    value: EApplicationStatus.CORRECTLY_FILLED, // Correctamente diligenciado
    label: 'Correctamente diligenciado',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.APPROVED, EApplicationStatus.REJECTED],
  },
  {
    className: 'approved',
    icon: <FaHouseCircleCheck />,
    value: EApplicationStatus.APPROVED,
    label: 'Aprobado',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.FINISHED],
  },
  {
    className: 'rejected',
    icon: <FaHouseCircleXmark />,
    value: EApplicationStatus.REJECTED,
    label: 'Rechazado',
    nextStatusAuto: false,
    nextStatus: [EApplicationStatus.FINISHED],
  },
  {
    className: 'finished',
    icon: <FaArchive />,
    value: EApplicationStatus.FINISHED,
    label: 'Finalizado o Archivado',
    nextStatusAuto: false,
    nextStatus: [],
  },
  {
    className: 'unsync',
    icon: null,
    value: EApplicationStatus.OFFLINE,
    label: 'Sin sincronizar',
    nextStatusAuto: false,
    nextStatus: [],
  },
]

export const APPLICATION_STATUS_OPTIONS = APPLICATION_STATUS.map((item) => {
  let itemLabel = item.label

  if (item.value === EApplicationStatus.IN_REVIEW) {
    itemLabel = 'En revisión'
  }

  return {
    value: item.value,
    label: itemLabel.toUpperCase(),
  }
})
